module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2818617776418c78a13966e88af8be50.png";